import { toAbsoluteUrl } from "_metronic/helpers";
import dayjs from "global/dayjs";

export default function getAbsoluteLogoURL() {
  // If December, show Christmas logo
  if (dayjs().month() == 11) {
    return toAbsoluteUrl("/proptimo-logo-christmas.svg");
  } else {
    return toAbsoluteUrl("/proptimo-logo.svg");
  }
}
